function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { Emitter } from '@okee-uikit/react-hooks';
import { compareDateTime, nextDate as _nextDate, nextMonth, nextYear, weekStart } from '@okee-uikit/react-utils';
import { RangeState } from '../util';
import { PanelType } from './BasePanel';
import { DatePanel } from './DatePanel';
import { MonthPanel } from './MonthPanel';
import { WeekPanel } from './WeekPanel';
import { YearPanel } from './YearPanel';
export var FrameSelectedType;

(function (FrameSelectedType) {
  FrameSelectedType[FrameSelectedType["REVERSE"] = 0] = "REVERSE";
  FrameSelectedType[FrameSelectedType["SELECT"] = 1] = "SELECT";
  FrameSelectedType[FrameSelectedType["UNSELECT"] = 2] = "UNSELECT";
})(FrameSelectedType || (FrameSelectedType = {}));

export var BaseDate = function (_Emitter) {
  _inherits(BaseDate, _Emitter);

  var _super = _createSuper(BaseDate);

  function BaseDate(panelType) {
    var _this;

    _classCallCheck(this, BaseDate);

    _this = _super.call(this);
    _this.point = 'range';
    _this.panelMap = {};
    _this.startDay = 0;
    _this.isValueValid = true;
    _this.outRangeDisabled = false;
    _this.needRangeValid = false;
    _this.disabled = false;
    _this.panelType = panelType;
    return _this;
  }

  _createClass(BaseDate, [{
    key: "isTrying",
    value: function isTrying() {
      return false;
    }
  }, {
    key: "isInvalidTryingDate",
    value: function isInvalidTryingDate() {
      return false;
    }
  }, {
    key: "addPanel",
    value: function addPanel(panel) {
      var part = panel.getPart();
      this.panelMap[part] = panel;
    }
  }, {
    key: "createPanel",
    value: function createPanel(panelType, part) {
      switch (panelType) {
        case PanelType.DATE:
          return this.createDatePanel(part);

        case PanelType.WEEK:
          return this.createWeekPanel(part);

        case PanelType.MONTH:
          return this.createMonthPanel(part);

        case PanelType.YEAR:
          return this.createYearPanel(part);

        default:
          return this.createDatePanel(part);
      }
    }
  }, {
    key: "createDatePanel",
    value: function createDatePanel(part) {
      var panel = new DatePanel({
        root: this,
        part: part
      });
      this.addPanel(panel);
      return panel;
    }
  }, {
    key: "createMonthPanel",
    value: function createMonthPanel(part) {
      var panel = new MonthPanel({
        root: this,
        part: part
      });
      this.addPanel(panel);
      return panel;
    }
  }, {
    key: "createYearPanel",
    value: function createYearPanel(part) {
      var panel = new YearPanel({
        root: this,
        part: part
      });
      this.addPanel(panel);
      return panel;
    }
  }, {
    key: "createWeekPanel",
    value: function createWeekPanel(part) {
      var panel = new WeekPanel({
        root: this,
        part: part
      });
      this.addPanel(panel);
      return panel;
    }
  }, {
    key: "updateOptions",
    value: function updateOptions(options) {
      var _options$outRangeDisa = options.outRangeDisabled,
          outRangeDisabled = _options$outRangeDisa === void 0 ? false : _options$outRangeDisa,
          _options$needRangeVal = options.needRangeValid,
          needRangeValid = _options$needRangeVal === void 0 ? false : _options$needRangeVal,
          _options$isDateDisabl = options.isDateDisabled,
          isDateDisabled = _options$isDateDisabl === void 0 ? function () {
        return false;
      } : _options$isDateDisabl,
          _options$isMonthDisab = options.isMonthDisabled,
          isMonthDisabled = _options$isMonthDisab === void 0 ? function () {
        return false;
      } : _options$isMonthDisab,
          _options$isYearDisabl = options.isYearDisabled,
          isYearDisabled = _options$isYearDisabl === void 0 ? function () {
        return false;
      } : _options$isYearDisabl,
          _options$startDay = options.startDay,
          startDay = _options$startDay === void 0 ? 0 : _options$startDay,
          _options$disabled = options.disabled,
          disabled = _options$disabled === void 0 ? false : _options$disabled,
          _options$point = options.point,
          point = _options$point === void 0 ? 'range' : _options$point;
      this.startDay = startDay;
      this.needRangeValid = needRangeValid;
      this.isDateDisabled = disabled ? function () {
        return true;
      } : isDateDisabled;
      this.isMonthDisabled = disabled ? function () {
        return true;
      } : isMonthDisabled;
      this.isYearDisabled = disabled ? function () {
        return true;
      } : isYearDisabled;
      this.outRangeDisabled = outRangeDisabled;
      this.disabled = disabled;
      this.point = point;
      this.repaintPanel();
    }
  }, {
    key: "getStartDay",
    value: function getStartDay() {
      return this.startDay;
    }
  }, {
    key: "isToday",
    value: function isToday(date) {
      return this.equalDate(date, new Date(), PanelType.DATE);
    }
  }, {
    key: "getPanel",
    value: function getPanel(part) {
      var panel = this.panelMap[part];

      if (!panel) {
        throw new Error("part=".concat(part, " panel is not under current RangeDate"));
      }

      return panel;
    }
  }, {
    key: "getAllPanel",
    value: function getAllPanel() {
      return this.panelMap;
    }
  }, {
    key: "getOutRangeDisabled",
    value: function getOutRangeDisabled() {
      return this.outRangeDisabled;
    }
  }, {
    key: "setPanelDate",
    value: function setPanelDate(part, date) {
      this.emit('set-panel-date', {
        part: part,
        date: date
      });
    }
  }, {
    key: "isGlobalDisabled",
    value: function isGlobalDisabled() {
      return this.disabled;
    }
  }, {
    key: "isDateDisabled",
    value: function isDateDisabled(date) {
      return false;
    }
  }, {
    key: "isWeekDisabled",
    value: function isWeekDisabled(startDate) {
      var date = weekStart(startDate, this.getStartDay());
      var needRangeValid = this.needRangeValid;

      for (var i = 0; i < 7; i++) {
        var disabled = this.isDateDisabled(date);

        if (needRangeValid && disabled) {
          return true;
        }

        if (!needRangeValid && !disabled) {
          return false;
        }

        date = _nextDate(date);
      }

      return !needRangeValid;
    }
  }, {
    key: "isMonthDisabled",
    value: function isMonthDisabled(date) {
      return false;
    }
  }, {
    key: "isYearDisabled",
    value: function isYearDisabled(date) {
      return false;
    }
  }, {
    key: "getTryingSelectedState",
    value: function getTryingSelectedState(date) {
      return RangeState.NONE;
    }
  }, {
    key: "setPanelFrameSelected",
    value: function setPanelFrameSelected(dateList, part, type, virtual) {
      this.setPanelSelected(dateList[0], part, virtual);
    }
  }, {
    key: "repaintPanel",
    value: function repaintPanel() {
      var _this2 = this;

      Object.keys(this.panelMap).forEach(function (part) {
        _this2.panelMap[part].repaint();
      });
    }
  }, {
    key: "compareDate",
    value: function compareDate(date1, date2, panelType) {
      if (date1 == null && date2 == null) {
        return 0;
      }

      if (date1 == null) {
        return -1;
      }

      if (date2 == null) {
        return 1;
      }

      return compareDateTime(panelType || this.panelType, date1, date2, this.startDay);
    }
  }, {
    key: "equalDate",
    value: function equalDate(date1, date2, panelType) {
      return this.compareDate(date1, date2, panelType) === 0;
    }
  }, {
    key: "lessThanDate",
    value: function lessThanDate(data1, date2, panelType) {
      return this.compareDate(data1, date2, panelType) < 0;
    }
  }, {
    key: "greaterThanDate",
    value: function greaterThanDate(data1, date2, panelType) {
      return this.compareDate(data1, date2, panelType) > 0;
    }
  }, {
    key: "isDisabled",
    value: function isDisabled(date) {
      switch (this.panelType) {
        case PanelType.DATE:
          return this.isDateDisabled(date);

        case PanelType.MONTH:
          return this.isMonthDisabled(date);

        case PanelType.YEAR:
          return this.isYearDisabled(date);

        case PanelType.WEEK:
          return this.isWeekDisabled(date);
      }
    }
  }, {
    key: "isSelected",
    value: function isSelected(date) {
      switch (this.panelType) {
        case PanelType.DATE:
          return this.isDateSelected(date);

        case PanelType.MONTH:
          return this.isMonthSelected(date);

        case PanelType.YEAR:
          return this.isYearSelected(date);

        case PanelType.WEEK:
          return this.isWeekSelected(date);
      }
    }
  }, {
    key: "nextDate",
    value: function nextDate(date) {
      var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

      switch (this.panelType) {
        case PanelType.DATE:
          return _nextDate(date, offset);

        case PanelType.MONTH:
          return nextMonth(date, offset);

        case PanelType.YEAR:
          return nextYear(date, offset);

        case PanelType.WEEK:
          return _nextDate(date, offset * 7);
      }
    }
  }, {
    key: "prevDate",
    value: function prevDate(date) {
      var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      return this.nextDate(date, -offset);
    }
  }]);

  return BaseDate;
}(Emitter);